var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('section',[_c('AddressForm',_vm._g({attrs:{"item":_vm.item,"errors":_vm.errors,"disabled":_vm.disabled}},_vm.$listeners)),_c('MediaForm',_vm._g({attrs:{"item":_vm.item,"errors":_vm.errors,"disabled":_vm.disabled}},_vm.$listeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }